<div class="d-flex flex-column gap-big">
  @for (item of moreMenuItems(); track item.name + $index) {
    <div
      class="px-medium bt-3 d-flex justify-content-start cursor-pointer"
      [ngClass]="$index !== moreMenuItems().length - 1 ? 'pt-minus' : 'pb-minus'"
      (click)="handleItemClick(item)"
    >
      {{ item.name }}
    </div>
    @if ($index !== moreMenuItems().length - 1) {
      <div class="w-100 border-b-100 border-color-tint"></div>
    }
  }
</div>
